// extracted by css-extract-rspack-plugin
export default {"input":"yVVPa","innerInput":"EVRdE","error":"pCGnu"};